import type { AppointmentForm } from '@devexpress/dx-react-scheduler-material-ui';
import * as React from 'react';

import EndRepeatEditorBase from './EndRepeatEditorBase';
import MonthlyRadioGroupEditorBase from './MonthlyRadioGroupEditorBase';
import YearlyRadioGroupEditorBase from './YearlyRadioGroupEditorBase';

/**
 * VITALL-styled radio group component for the routine recurrence form
 */
const RadioGroup = ({ ...props }: AppointmentForm.RadioGroupProps) => {
  const { type } = props;
  switch (type) {
    case 'endRepeat':
      return <EndRepeatEditorBase {...props} />;
    case 'monthlyRadioGroup':
      return <MonthlyRadioGroupEditorBase {...props} />;
    case 'yearlyRadioGroup':
    default:
      return <YearlyRadioGroupEditorBase {...props} />;
  }
};

export default RadioGroup;
